import React, { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
// import { hasSellerAuthExpressType } from '@/services/apis'
import { useSelector } from '@/store'
import styles from './index.module.less'
import { ContractDetailRes, OsContractStatusEnum, postContractDetail } from '@/services/api'
import { Button, Modal, Radio } from 'antd-mobile'
import step1 from '@/assets/imgs/step1.png'
import step2 from '@/assets/imgs/step2.png'
/**
 * 跨境商家需要校验签约状态才可以发货
 * @returns
 */
export const useCNSign = () => {
  const { t } = useTranslation()
  const { userInfo } = useSelector((s) => s.auth)
  const selectUrlIndex = useRef<number>()
  const step = useRef<number>(0)

  const toOCSign = () => {
    location.href = `${process.env.ONECLUB_URL}/admin/sign`
  }

  const onOk = useCallback(
    (oaUrls: ContractDetailRes['oaContractUrls']) => {
      // 未发起过合同
      if (step.current === 0) {
        toOCSign()
      }
      // 未完成合同，继续签署
      if (step.current === 1 && oaUrls?.length) {
        const defalutValueIndex = 0
        selectUrlIndex.current = defalutValueIndex
        // 多个合同，需要手动选择一个
        if (oaUrls?.length > 1) {
          Modal.show({
            title: t('sign.url.modal.title'),
            closeOnMaskClick: true,
            closeOnAction: true,
            content: (
              <div className={styles.oaContractUrls}>
                <div>{t('sign.url.modal.content')}</div>
                <Radio.Group onChange={(val) => (selectUrlIndex.current = val as number)} defaultValue={defalutValueIndex}>
                  {oaUrls.map((item, index) => (
                    <div key={item.oaContractUrl + index}>
                      <Radio value={index}>{item.phone}</Radio>
                    </div>
                  ))}
                </Radio.Group>
              </div>
            ),
            actions: [
              {
                key: 'ok',
                primary: true,
                text: t('frame.confirm'),
                onClick: () => {
                  if (selectUrlIndex.current === undefined) {
                    return Promise.reject()
                  }
                  location.href = oaUrls[selectUrlIndex.current]?.oaContractUrl
                  selectUrlIndex.current = undefined
                },
              },
              {
                key: 'cancel',
                text: t('frame.cancel'),
                onClick: () => {
                  selectUrlIndex.current = undefined
                },
              },
            ],
          })
        } else {
          location.href = oaUrls[defalutValueIndex]?.oaContractUrl
        }
      }
      return Promise.reject(false)
    },
    [t]
  )

  return useCallback(() => {
    return new Promise(async (res) => {
      // 跨境版本与预付才需要签约
      if (userInfo.countryCode === 'CN' && userInfo.isPrepaid) {
        // 签约状态
        const { data } = await postContractDetail()
        // 已签约完成
        if (data?.osContractStatus === OsContractStatusEnum.SIGNED) {
          return res(true)
        }
        // 未签约
        if (data?.osContractStatus === OsContractStatusEnum.UNSIGNED) {
          // 签约中 step2
          if (data?.oaContractUrls?.length && data?.oaContractUrls?.some((it) => it.thirdSignStates.find((state) => ['REALNAME', 'SENT'].includes(state)))) {
            step.current = 1
          }

          Modal.show({
            closeOnMaskClick: true,
            title: t('sign.title'),
            actions: [],
            onClose: () => res(false),
            bodyStyle: {
              padding: '21px 0 0',
            },
            content: (
              <div className={styles.content}>
                <div style={{ padding: '0 15px' }}>
                  <p className={styles.titleDec}>{t(`sign.step.${step.current}.content`)}</p>
                  <img src={step.current === 0 ? step1 : step2} style={{ width: '250px', height: '24px' }} />
                </div>
                <div>
                  <div style={{ marginTop: '22px' }}>
                    {step.current === 0 ? (
                      <Button onClick={() => onOk(data.oaContractUrls)} style={{ width: '100%', borderRadius: '0' }}>
                        <span style={{ color: '#15BBB9' }}> {t('sign.confirm.0')}</span>
                      </Button>
                    ) : null}
                    {step.current === 1 ? (
                      <Button onClick={toOCSign} style={{ width: '50%', borderRadius: '0', borderBottom: 'none' }}>
                        {t('sign.reconfirm')}
                      </Button>
                    ) : null}
                    {step.current === 1 ? (
                      <Button onClick={() => onOk(data.oaContractUrls)} style={{ width: '50%', borderRadius: '0' }}>
                        <span style={{ color: '#15BBB9' }}>{t('sign.confirm.1')}</span>
                      </Button>
                    ) : null}
                  </div>
                </div>
              </div>
            ),
          })

          return res(false)
        }
      }
      return res(true)
    })
  }, [onOk, t, userInfo.countryCode, userInfo.isPrepaid])
}
